import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import type { ReactNode } from "react";

export interface ModeToggleOption {
    value: string;
    label: string;
    icon?: ReactNode;
}

export interface ModeToggleProps {
    options: ModeToggleOption[];
    value: string;
    onChange: (value: string) => void;
}

export const ModeToggle = ({ options, value, onChange }: ModeToggleProps) => {
    const handleChange = (_event: React.MouseEvent<HTMLElement>, newValue: string | null) => {
        if (newValue !== null) {
            onChange(newValue);
        }
    };

    return (
        <ToggleButtonGroup exclusive value={value} onChange={handleChange}>
            {options.map((option) => (
                <ToggleButton key={option.value} value={option.value}>
                    {option.icon && (
                        <Box
                            component="span"
                            sx={{ display: "inline-flex", alignItems: "center", mr: 0.75, "& svg": { width: 16, height: 16 } }}
                        >
                            {option.icon}
                        </Box>
                    )}
                    {option.label}
                </ToggleButton>
            ))}
        </ToggleButtonGroup>
    );
};
